import { AppConfig } from '@hfc/ui-core';
import { MedicareAgentCollection } from '@/consent/medicare/domain/MedicareAgentCollection';
import { MedicareSettingsUseCase } from '@/consent/medicare/application/MedicareSettingsUseCase';
import { MedicareSettingsMemory } from '@/consent/medicare/infrastructure/dataSource/MedicareSettingsMemory';
import { visionRouter } from '@/application/vision/infrastructure/visionRouter';
import { dentalRouter } from '@/application/dental/infrastructure/dentalRouter';
import { medicareConsentRouter } from '@/consent/medicare/infrastructure/medicareConsentRouter';
import { smallBusinessRouter } from '@/application/smallBusiness/infrastructure/router';
import FeedbackChallengeQuestions from '@/shared/infrastructure/views/FeedbackChallengeQuestions.vue';
import UserFeedback from '@/shared/infrastructure/views/UserFeedback.vue';
import FeedbackThankYou from '@/shared/infrastructure/views/FeedbackThankYou.vue';
import { healthRouter } from '@/application/health/infrastructure/healthRouter';

const medicareSettingsRepository = new MedicareSettingsMemory();
const medicareSettings = new MedicareSettingsUseCase(medicareSettingsRepository);

const baseUrl = import.meta.env.VITE_APP_BASE_URL;
const agentCollection = await medicareSettings.run();

export interface EnrollmentAppConfig extends AppConfig {
  agentCollection: MedicareAgentCollection
}

export const appConfig: EnrollmentAppConfig = {
  tracking: {
    enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
    dsn: import.meta.env.VITE_SENTRY_DSN,
    metadata: {
      tags: {
        app_id: 'enrollment-ui'
      }
    }
  },
  router: {
    routes: [
      {
        path: '/',
        name: 'Home',
        children: [],
        beforeEnter: (): boolean => {
          window.location.href = baseUrl;

          return false;
        }
      },
      {
        path: '/feedback',
        name: 'Feedback',
        redirect: {
          name: 'UserFeedback'
        },
        children: [
          {
            path: ':applicationType?/:uuid?',
            name: 'UserFeedback',
            component: UserFeedback,
          },
          {
            path: ':applicationType/:uuid/challenge',
            name: 'FeedbackChallengeQuestions',
            component: FeedbackChallengeQuestions,
          },
          {
            path: '/thank-you',
            name: 'FeedbackThankYou',
            component: FeedbackThankYou,
          }
        ],
      },
      medicareConsentRouter,
      smallBusinessRouter,
      visionRouter,
      dentalRouter,
      healthRouter
    ] },
  tailwind: {
    enabled: true
  },
  analytics: {
    enabled: false
  },
  screenIndicator: import.meta.env.VITE_SCREEN_INDICATOR_ENABLED === 'true',
  icons: {
    enabled: true
  },
  webSocket: {
    channelName: 'enrollment',
    url: import.meta.env.VITE_WEBSOCKET_SERVER_URL ?? ''
  },
  agentCollection
};
